import { useQuery } from '@tanstack/react-query'
import SalesReportsAPI from '../api/SalesReportsAPI'
import {
  MenuItemsSalesTableByLanguagePayloadModel,
  QUERY
} from '../api/SalesReportsAPI.model'

function useMenuItemsSalesTable(params: MenuItemsSalesTableByLanguagePayloadModel) {
  const enabled = Boolean(params.startDate && params.endDate)
  return useQuery({
    queryKey: [
      QUERY.MENU_ITEMS_SALES_TABLE_BY_LANGUAGE,
      params.startDate,
      params.endDate,
      params.limit,
      params.itemFilter
    ],
    queryFn: () => SalesReportsAPI.getMenuItemsSalesTableByLanguage(params),
    enabled,
    refetchOnWindowFocus: false
  })
}

export default useMenuItemsSalesTable
